import { TFunction } from 'language/translator'

const MS_PER_DAY = 1000 * 60 * 60 * 24

export const parseDateString = (dateString: string) => {
  const date = new Date(dateString).toLocaleDateString('sv-SE')
  const time = new Date(dateString).toLocaleTimeString('sv-SE').split(':')

  time.pop()

  return `${date} kl. ${time.join(':')}`
}

/**
 * Check if data type is of DATE or TIMESTAMP
 * @param {object} dtype - data type to check
 * @returns {boolean} - Data type is date/timestamp.
 */
export const isDateType = (dtype: string) =>
  ['DATE', 'TIMESTAMP'].includes(dtype)

/**
 * Calculates the elapsed time since @param dateString in a formatted
 * response.
 */
export const parseElapsedTimeSince = (
  inputDate: Date | string | null,
  t: TFunction
) => {
  if (inputDate === null) {
    return ''
  }

  let date: Date = new Date(0)

  if (typeof inputDate === 'string') {
    date = new Date(inputDate)
  } else {
    date = inputDate
  }

  const now = new Date()

  const timeDiff = Math.abs(now.valueOf() - date.valueOf())
  const diffInDays = Math.round(timeDiff / MS_PER_DAY)

  // Parse out seconds, minutes or hours
  if (diffInDays < 1) {
    const diffInHours = Math.round(timeDiff / (1000 * 60 * 60))
    const diffInMinutes = Math.round(timeDiff / (1000 * 60))
    const diffInSeconds = Math.round(timeDiff / 1000)

    if (diffInHours < 1 && diffInMinutes < 1) {
      return `${diffInSeconds} ${t(
        'global',
        diffInSeconds === 1 ? 'second' : 'seconds',
        true
      )}`
    } else if (diffInHours < 1) {
      return `${diffInMinutes} ${t(
        'global',
        diffInMinutes === 1 ? 'minute' : 'minutes',
        true
      )}`
    } else {
      return `${diffInHours} ${t(
        'global',
        diffInHours === 1 ? 'hour' : 'hours',
        true
      )}`
    }
  }

  // Parse out weeks, months or years
  if (diffInDays > 6) {
    if (diffInDays >= 365) {
      const diffInYears = Math.floor(diffInDays / 365)

      return `${diffInYears} ${t(
        'global',
        diffInYears === 1 ? 'year' : 'years',
        true
      )}`
    } else if (diffInDays >= 28) {
      const diffInMonths = Math.floor(diffInDays / 28)

      return `${diffInMonths} ${t(
        'global',
        diffInMonths === 1 ? 'month' : 'months',
        true
      )}`
    } else {
      const diffInWeeks = Math.floor(diffInDays / 7)

      return `${diffInWeeks} ${t(
        'global',
        diffInWeeks === 1 ? 'week' : 'weeks',
        true
      )}`
    }
  }

  return `${diffInDays} ${t('global', diffInDays === 1 ? 'day' : 'days', true)}`
}

export function isValidDate(toValidate: Date) {
  return toValidate instanceof Date && !isNaN(toValidate.getTime())
}
